"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ProductPresentation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="patientadvocacy" className="relative bg-background pt-8 pb-16 lg:pt-12 lg:pb-20 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-chart-2/5 blur-3xl" />
      </div>

      <div ref={ref} className={cn("container mx-auto px-6 md:px-8 max-w-5xl relative z-10 transition-all duration-1000", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="rounded-3xl border border-border/50 bg-card/50 backdrop-blur-md shadow-lg p-8 md:p-12 lg:p-16">
          <div className="max-w-4xl mx-auto text-center">
            <Badge variant="outline" className="mb-6 border-chart-2/20 text-chart-2 bg-chart-2/5 px-4 py-1 text-sm rounded-full">
              Patient Advocacy
            </Badge>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-foreground tracking-tight mb-8">
              The Power of Being an Informed Patient
            </h2>

            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-6">
              In today’s healthcare system, patients who understand their
              condition and actively advocate for themselves are more likely to
              receive the care and testing they need.
            </p>

            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-10">
              <Link to="https://pmc.ncbi.nlm.nih.gov/articles/PMC10037728/pdf/10.1177_10732748221143884.pdf" newTab className="text-chart-2 hover:underline transition-colors">Research</Link> shows that when patients ask informed questions or request
              specific evaluations, providers are more likely to order additional
              testing or referrals. Without that advocacy, important opportunities,
              such as genetic or genomic testing, can be missed.
            </p>

            <div className="mx-auto max-w-3xl rounded-2xl bg-chart-2/5 border border-chart-2/10 px-8 py-8 mb-10">
              <p className="text-xl font-serif text-primary leading-relaxed !italic md:text-2xl">Many patients who meet criteria for advanced testing still do not receive it in routine practice, often because the ordering physician isn't aware of the most current guideline recommendations, not because the testing isn't warranted.</p>
              <div className="mt-6">
                <Link to="https://www.targetedonc.com/view/gaps-in-genetic-testing-and-targeted-therapy-for-advanced-prostate-cancer" newTab target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-7 py-3.5 text-base font-medium text-primary-foreground bg-primary hover:bg-primary/90 rounded-lg shadow transition-colors">
                  Read the Research
                </Link>
              </div>
            </div>

            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
              I help you understand your diagnosis, your options, and the right
              questions to ask so you can take an active role in your care and
              help ensure nothing important is overlooked.
            </p>
          </div>
        </div>
      </div>
    </section>;
}